import { render } from "./VODTags.vue?vue&type=template&id=09a6d079"
import script from "./VODTags.vue?vue&type=script&setup=true&lang=js"
export * from "./VODTags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/VODTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09a6d079"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09a6d079', __exports__)) {
    api.reload('09a6d079', __exports__)
  }
  
  module.hot.accept("./VODTags.vue?vue&type=template&id=09a6d079", () => {
    api.rerender('09a6d079', render)
  })

}


export default __exports__